export default __webpack_public_path__ + "static/media/instagram.2e4a2c2f.png";